/* eslint-disable react-hooks/exhaustive-deps */
import Header from "../../components/Header/Header";
import "./styles.css";
import { useContext, useEffect, useState } from "react";
import CardNF from "./components/CardNF";

import { Context } from "../../hooks/useAuthContext";

import ModalNF from "./components/ModalNF";
import { formatarMoeda } from "../../utils/formatMoeda";
import ModalChavesPix from "../../components/ModalChavesPix/ModalChavesPix";
import Swal from "sweetalert2";
import { useNavigate, useSearchParams } from "react-router-dom";
import { getDataDoismesesAtras } from "../../utils/doismeses";

function EmitirNotaFiscal() {
  const { userData, exibirLogs, buscarNotasFiscaisPorMes } =
    useContext(Context);

  const [searchParams] = useSearchParams();
  const navigate = useNavigate();

  // NOVO: Lê o tipo de nota e a data da URL.
  const tipoNota = searchParams.get("tipo") || "normal";
  const dataParam = searchParams.get("data");

  const [data, setData] = useState("");
  const [showModalNF, setShowModalNF] = useState(false);
  const [notasBuscadas, setNotasBuscadas] = useState(null);
  const [modalChavePixAberto, setModalChavePixAberto] = useState(false);
  const [selectedDatePeriod, setSelectedDatePeriod] = useState(new Date());

  useEffect(() => {
    const dateObject = dataParam ? new Date(dataParam) : new Date();
    setSelectedDatePeriod(dateObject);
    const resultado = getDataDoismesesAtras(dateObject);
    if (resultado) {
      setData(resultado);
    }
  }, [dataParam]);

  useEffect(() => {
    if (!userData?.uid || !data) {
      return;
    }

    async function fetchNotas() {
      try {
        exibirLogs && console.log(`Buscando notas para o mês: ${data}, tipo: ${tipoNota}`);
        
        const todasAsNotas = await buscarNotasFiscaisPorMes(userData.uid, data);

        // Filtra pelo tipo de nota especificado na URL
        const notasDoTipo = todasAsNotas.filter(n => n.tipoNota === tipoNota);
        
        const notaParaEmitir = notasDoTipo.find(
          (nota) => nota.status === "cancelado" || nota.status === "pendente"
        );

        if (notaParaEmitir) {
          setNotasBuscadas(notaParaEmitir);
        } else {
          Swal.fire({
            title: "Nenhuma Nota Fiscal pendente encontrada",
            text: `Você não possui notas do tipo '${tipoNota}' pendentes para este período.`,
            icon: "info",
            confirmButtonText: "Voltar para o início",
            backdrop: "rgba(0, 0, 0, 1)",
            allowOutsideClick: false,
            allowEscapeKey: false,
          }).then((result) => {
            if (result.isConfirmed) {
              navigate("/");
            }
          });
        }
      } catch (err) {
        exibirLogs && console.error(`Erro ao buscar nota fiscal do tipo ${tipoNota}:`, err);
        Swal.fire({
            title: "Erro ao buscar nota",
            text: "Ocorreu um erro ao buscar sua nota fiscal. Tente novamente mais tarde.",
            icon: "error",
            confirmButtonText: "Voltar"
        }).then(() => navigate('/'));
      }
    }

    fetchNotas();
  }, [userData, data, tipoNota, buscarNotasFiscaisPorMes, exibirLogs, navigate]);

  useEffect(() => {
    if (!userData) {
      return;
    }

    const semDocumentos = !userData.documentoFrente || !userData.documentoVerso;
    if (semDocumentos && userData.tipoConta !== "afiliado") {
      Swal.fire({
        title: "Documentos incompletos!",
        text: "Para emitir a nota fiscal, envie seus documentos.",
        icon: "warning",
        confirmButtonText: "Atualizar documentos",
        allowOutsideClick: false,
        allowEscapeKey: false,
      }).then((result) => {
        if (result.isConfirmed) {
          navigate("/atualizar-dados");
        }
      });

      return;
    }
  }, [userData, navigate]);

  useEffect(() => {
    const precisaCadastrarChavePix =
      !userData?.chavesPix || userData?.chavesPix?.length === 0;

    if (precisaCadastrarChavePix) {
      setModalChavePixAberto(true);
    }
  }, [userData]);

  function formatarDataMesAno(date) {
    if (!date || isNaN(date.getTime())) {
        return "Data Inválida";
    }
    const mes = date.toLocaleDateString("pt-BR", { month: "long" });
    const ano = date.getFullYear();
    return `${mes.charAt(0).toUpperCase() + mes.slice(1)}/${ano}`;
  }

  let dataInicioNota;
  let dataFimNota;

  if (notasBuscadas) {
    const [mes, ano] = notasBuscadas.date.split("/");
    const primeiroDiaNota = new Date(Number(ano), Number(mes) - 1, 1);
    primeiroDiaNota.setHours(0, 0, 0, 0);
    dataInicioNota = primeiroDiaNota.getTime();

    const ultimoDiaNota = new Date(Number(ano), Number(mes), 0);
    ultimoDiaNota.setHours(23, 59, 59, 999);
    dataFimNota = ultimoDiaNota.getTime();
  }

  const textoDataExibida = formatarDataMesAno(selectedDatePeriod);

  return (
    <div className="contentNf">
      <Header urlFoto="https://i.imgur.com/nCIToeZ.png" />

      {notasBuscadas ? (
        <div className="wrapper">
          <h1 className="titleNf">Emissão disponível</h1>

          <div>
            <h3 className="cardTitleNf">Mês da receita</h3>
            <div style={{ color: "white" }}>{textoDataExibida}</div>
          </div>

          <div style={{ marginTop: 15 }}>
            <CardNF
              isEmiting={true}
              values={notasBuscadas?.values}
              status={notasBuscadas?.status}
              dataInicio={dataInicioNota}
              dataFim={dataFimNota}
              tipoNota={searchParams.get("tipo")}
            />
          </div>

          <div className="dadosEmpresa">
            <span style={{ marginBottom: 5 }}>
              <b> Dados para Emissão da NFS-e</b>
            </span>
            <span>
              <strong>Link do Bem</strong>
            </span>
            <span>
              <strong>CNPJ:</strong> 54.605.482/0001-32
            </span>
          </div>

          <div className="totalNota">
            <span>
              {notasBuscadas?.values.valorEmRealComDesconto < 0
                ? "Nota com valor negativo"
                : `Valor da nota (${tipoNota}) a ser emitida`}
            </span>
            <span>
              R${" "}
              {formatarMoeda(
                Number(notasBuscadas?.values.valorEmRealComDesconto)
              )}
            </span>
          </div>

          {(userData?.chavesPix > 0) && (
            <button className="btnEmitirNf" onClick={() => setShowModalNF(true)}>
              {notasBuscadas?.values?.valorEmRealComDesconto > 50
                ? "Enviar Nota Fiscal"
                : notasBuscadas?.values?.valorEmRealComDesconto < 0
                ? "Prosseguir"
                : "Solicitar Pagamento"}
            </button>
          )}
        </div>
      ) : (
        <div className="wrapper" style={{color: "white", textAlign: "center"}}>
            Carregando dados da nota fiscal...
        </div>
      )}

      <ModalNF
        isOpen={showModalNF}
        toggle={() => setShowModalNF(false)}
        receiptNfPeriod={notasBuscadas}
        id={notasBuscadas?._id}
      />

      <ModalChavesPix
        isOpen={modalChavePixAberto}
        onClose={() => setModalChavePixAberto(false)}
        chavesPix={userData.chavesPix}
        cadastroObrigatorio={true}
      />
    </div>
  );
}

export default EmitirNotaFiscal;